import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import localizationService from './services/Localization/i18n';
import BootSpinner from 'outlookComponents/BootSpinner';
import Config from 'services/Config/configService';
import './index.css';

// The app shell is loaded lazily so the entry bundle only carries what is needed to paint the first frame.
// Everything App reaches - Fluent UI, the shared models with their joi schemas, MSAL, the Graph client - moves
// into a preloaded async chunk. Keep the imports above free of anything that reaches App/, baseComponents/ or
// services/Api: logService, for instance, imports userService and with it the entire model tree, which is why
// the boot logging below goes straight to the console.
const App = lazy(() => import(/* webpackPreload: true */ './App/App'));

const addInVersion: string = '6.3.4';

localizationService.init();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function itemChanged(eventArgs: any) {
  // Update UI based on the new current item
  console.debug('item changed');
  UpdateTaskPaneUI(Office.context.mailbox.item);
}

//eslint-disable-next-line @typescript-eslint/no-explicit-any
function UpdateTaskPaneUI(item: any) {
  console.debug('full item', item);

  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback={<BootSpinner />}>
        <App item={item} />
      </Suspense>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

Office.initialize = () => {
  console.log(`Start add-in version ${addInVersion} in environment: ${Config.getAppEnv()}`);

  // Set up ItemChanged event
  Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, itemChanged);

  // Trigger the main render
  UpdateTaskPaneUI(Office.context.mailbox.item);
};
